import { all, call } from 'redux-saga/effects';
import authSaga from '../screens/auth/sagas';
import dashboardSaga from '../screens/Dashboard/sagas';
import downloadsSaga from '../screens/DownloadChallenges/sagas';
import mapSaga from '../map/sagas';
import challengesSaga from '../screens/Challenges/sagas';
import challengeSaga from '../screens/Challenge/sagas';
import segmentsSaga from '../screens/Segments/sagas';
import analysisSaga from '../screens/Analysis/saga';
import resourcesSaga from '../screens/Resources/sagas';
import adminSaga from '../screens/Admin/sagas';
import monitorSaga from '../screens/Monitor/sagas';
import campaignsSaga from '../screens/Campaigns/sagas';
import campaignSaga from '../screens/Campaign/sagas';
import researchSaga from '../screens/Research/redux/sagas';
import createChallengeSaga from '../screens/CreateChallenge/redux/sagas';

// single entry point to start all Sagas at once
export default function* rootSaga() {
    yield all([
        // all of the app related sagas will go here
        call(authSaga),
        call(dashboardSaga),
        call(downloadsSaga),
        call(mapSaga),
        call(challengesSaga),
        call(challengeSaga),
        call(segmentsSaga),
        call(analysisSaga),
        call(resourcesSaga),
        call(adminSaga),
        call(monitorSaga),
        call(campaignsSaga),
        call(campaignSaga),
        call(researchSaga),
        call(createChallengeSaga),
    ]);
}
